module.exports = __webpack_public_path__ + "static/media/gh-high-life-tributes.320c3299.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sliders/gh-high-life-tributes.jpg
// module id = 46
// module chunks = 0